import styled from 'styled-components'

export const Wrapper = styled.div`
    margin-top: 20px;
`

export const NavWrapper = styled.div`
    margin: 0;
    padding: 10px 0;

    @media (max-width: 334px) {
        display: grid;
        grid-gap: 10px;
        text-align: center;
    }
`

export const FormHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0 15px;

    @media (max-width: 528px) {
        display: block;
    }
`

export const SubstanceItem = styled.div`
    line-height: 1.3em;
`

export const CustomFieldWrapper = styled.label`
    display: grid;
    grid-template-columns: 11fr 1fr;
    line-height: 1.3em;
    margin-bottom: 0.5em;
`

export const Span = styled.span`
    font-weight: 400;
`

export const Point = styled.div`
    text-align: center;
`
export const FieldItem = styled.div`
    cursor: pointer;
`

export const Button = styled.button`
    &:focus {
        outline: none;
    }
`
export const Block = styled.div`
    line-height: 1.3em;
    margin-bottom: .5em;
`
